import { useQuery } from '@tanstack/react-query'
import { useApi } from './useApi'

interface EnvironmentUpdateGetRequest {
  mimicId?: string
  chainId?: string
  submitted?: boolean
  limit?: number
  page?: number
  completed?: boolean
}

const fetchEnvironmentUpdates = async (
  callApi: any,
  params: EnvironmentUpdateGetRequest
): Promise<any> => {
  return await callApi(`/environments/updates`, params)
}

export const useEnvironmentUpdates = (params: EnvironmentUpdateGetRequest) => {
  const { callApi } = useApi()

  return useQuery<any>({
    queryKey: ['environmentUpdates', params],
    queryFn: () => fetchEnvironmentUpdates(callApi, params),
  })
}
